import React from "react";

export default function Spinner() {
  return (
    <div className="col-12 text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">{i18n.getString("loading")}</span>
      </div>
    </div>
  );
}
